import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import React from "react";
import Text from "./Text";

function BlogListHeader() {
  return (
    <Box bg="pink" pt={[100, null, 120, null]} pb={[25, null, 60, null]}>
      <BoxWithGutter>
        <Text as="h1" uppercase fontSize={[26, 44, 62, 62]} lineHeight={1}>
          The RE_EDIT
        </Text>
      </BoxWithGutter>
    </Box>
  );
}

export default BlogListHeader;
